<script setup lang="ts">
// types
import type { StrapiFooterLinkColumn } from '@ts-strapi/interfaces'
// components
import { AppText, AppTextLink } from '@UI/Typography/AppText'

defineOptions({
  name: 'FooterColumn',
})

defineProps<{
  column: StrapiFooterLinkColumn
}>()
</script>

<template>
  <section class="footer-column">
    <AppText
      class="footer-column__title"
      tag="p"
      :name="{base: 'body3-medium', 740: 'body2-medium'}"
      color="white"
    >
      {{ column.title }}
    </AppText>

    <ul class="footer-column__links">
      <li
        v-for="link in column.links"
        :key="link.url"
      >
        <AppTextLink
          :href="link.url"
          color="white"
          :name="{base: 'body4-medium', 740: 'body3'}"
        >
          {{ link.label }}
        </AppTextLink>
      </li>
    </ul>
  </section>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Footers/FooterColumn.scss" />
